<template>
  <div class="app">
    <router-view/>
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>


<style lang="scss">
@import "normalize.css";
@import "./assets/css/font.css";

.app {
  /* id(#) だと優先度が高すぎて上書きしにくいので class(.) にしている。 */
//  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: 'Noto Sans Japanese', 'Lucida Grande', 'Hiragino Kaku Gothic ProN', Meiryo, sans-serif;

  color: #666;
  line-height: 1.5em;
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    margin: 0 10px;
  }
  a {
    text-decoration: none;
    &:visited {
      // ここ色変えないとリンクであることがほぼわからなくなってしまう
      color: darkblue;
    }
  }
  // footerの下の空き領域をmainを伸ばして埋める
  > div {
    height: 100vh;
    display: flex;
    flex-direction: column;
    header, footer {
      flex: 0 0 auto;
    }
    main {
      flex: 1 0 auto;
    }
  }
}

textarea::placeholder {
  opacity: 0.5;
}

button:hover {
  cursor: pointer;
}

@media (min-width: 576px) {
  .ltexs {
    // Less Than or Equal to XS の略
    display: none !important;
  }
}
@media (max-width: 575px) {
  .gtxs {
    // Greater Than XS の略
    display: none !important;
  }
}
@media (min-width: 768px) {
  .ltesm {
    // Less Than or Equal to SM の略
    display: none !important;
  }
}
@media (max-width: 767px) {
  .gtsm {
    // Greater Than SM の略
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue